import { render } from "./ViewEntriesNumbers.vue?vue&type=template&id=754c7d90&scoped=true"
import script from "./ViewEntriesNumbers.vue?vue&type=script&lang=js"
export * from "./ViewEntriesNumbers.vue?vue&type=script&lang=js"

import "./ViewEntriesNumbers.vue?vue&type=style&index=0&id=754c7d90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-754c7d90"]])

export default __exports__